import axios from 'axios'
import Element from 'element-ui'
import router from './router'
import store from './store'
import common from './common'
import tool from './tool'

import './assets/css/tokenerror.css'

//生产环境
 axios.defaults.baseURL = "http://www.fjcsyit.com:9015"
//内网环境
// axios.defaults.baseURL = "http://192.168.2.230:9015"
//axios.defaults.withCredentials = true;


// 前置拦截
axios.interceptors.request.use(config => {
    let token = store.state.token;
    if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers.Authorization = token;
    }
    return config
},error => {
    console.log(error);
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    let res = response.data;

    if (res.code === 200) {
      common.TokenInvalidCounter=0
    }else if(res.code === 450){//后端主动返回的错误信息
      Element.Message({message: response.data.msg,type: 'error'});
      return Promise.reject(response)
    }else if(!res.code){//code为空
      return response
    } else {//状态值为500或者其他 如400
      Element.Message({message: "系统异常!",type: 'error'});
      return Promise.reject(response)
    }
    return response
  },
  error => {
    if(error.response.data) {
      error.message = error.response.data.msg
    }
    if(error.response.status === 401) {
      store.commit("REMOVE_INFO")
      router.push("/login")
    }
    let msg="token已失效，请重新登录"
    if(error.response.status === 500 && msg===error.response.data.message) {
        error.message = error.response.data.message
        store.commit("REMOVE_INFO")
        if (common.TokenInvalidCounter === 0){
          Element.Message({message: "token失效,请重新登录!",type: 'error'});
        }
        common.TokenInvalidCounter++
        router.push("/login")
        return
    }
    return Promise.reject(error)
  }
)

